import React, { useState, useEffect } from "react";
import { AiOutlineMail } from "react-icons/ai";
import { BsTelephone } from "react-icons/bs";
import { Button } from "react-bootstrap";
import Header from "../Header";
import Footer from "../Footer";

import { useTranslation } from "react-i18next";

import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";

import Loader from "../../Loader";
import { toast } from "react-toastify";
import axios from "axios";
import { blobURL } from "common/StringUtils";
import ContactUsForm from "./ContactUsForm";
import { LOCALES } from "common/constants";
import { getSchemaMarkup } from "common/FunctionUtils";

const ContactUs = ({ dashboardFooter }) => {
  const schemaMarkup = getSchemaMarkup("kontakta-oss");
  const { t } = useTranslation();
  const contact = `${blobURL}/contactbanner.jpg`;
  const language = localStorage.getItem("i18nextLng");

  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (values) => {
    try {
      setLoading(true);
      const res = await axios.post("/contactus", {
        ...values,
      });
      if (res?.status === 200) {
        setLoading(false);
        reset({
          name: "",
          subject: "",
          email: "",
          message: "",
          phoneNumber: "",
        });
        toast.success(
          language === LOCALES.EN_US ? t(res?.data?.response) : res?.data?.response
        );
      }
    } catch (error) {
      if (error?.response?.data) {
        toast.error(t(error?.response?.data?.message));
      } else {
        toast.error(t(error?.message));
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const divStyle = {
    backgroundImage: `linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${contact})`,
  };

  return (
    <>
      <Helmet>
        {schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(schemaMarkup)}
          </script>
        )}
        <title>{t("Contact us | Invoice now")}</title>
        <meta
          name="description"
          content={t(
            "Contact Invozio at support@invozio.com or call 010-264 88 10 – we’ll help you with everything related to invoicing without a company, quickly and easily!"
          )}
        />
        {language === LOCALES.EN_US ? (
          <link rel="canonical" href="https://invozio.com/contact-us" />
        ) : (
          <link rel="canonical" href="https://invozio.com/kontakta-oss" />
        )}
      </Helmet>

      <Header />
      {loading && <Loader />}

      <section className="contactus new_margin_header" id="contactus">
        <div className="banner-image" style={divStyle}>
          <div className="container">
            <div className="row">
              <div className="col-md-7">
                <div className="left-container">
                  <div className="hading-text">
                    <h1 className="font-weight-bold text-uppercase text-light text-left pt-0 mb-4">
                      {t("Contact Us")}
                    </h1>
                  </div>
                  <p className="contact_para">
                    {t(
                      "Do you have questions or need support? We at Invozio are here to help you! Whether you need more information about our services, want to become an ambassador or have general questions, we are ready to help."
                    )}
                  </p>

                  <h2 className="text-primary font-weight-bold text-left pt-0 h6 contact_head">
                    {t("Our invoice specialists for freelancers")}
                  </h2>
                  <h6 className="phone_hea">{t("Contact details")}</h6>
                  <p className="contact_para last">
                    <BsTelephone /> 010-264 88 10 &nbsp;&nbsp;{t("or")}
                    &nbsp;&nbsp;
                    <AiOutlineMail /> support@invozio.com
                  </p>
                  <p className="contact_para last">
                    {t(
                      "For support inquiries related to finance, IT, and contractual matters, we will only respond via email within two working days."
                    )}
                  </p>

                  <p className="contact_para last">
                    {t(
                      "Opening Hours: Weekdays 09:00-11:00 and 13:00-15:00. Closed on public holidays and the day before public holidays."
                    )}
                  </p>
                  <div className="btns pb-4 mt-2 cntact-us-buttons">
                    <Button
                      variant="primary number_but"
                      href={`tel:${import.meta.env.VITE_SUPPORT_PHONE_NUMBER}`}
                      className="mt-2 text-light new_theme_btn"
                    >
                      <BsTelephone className="mr-2"></BsTelephone>{import.meta.env.VITE_SUPPORT_PHONE_NUMBER}
                    </Button>

                    <Button
                      variant="primary number_but"
                      href="mailto:support@invozio.com"
                      className="mt-2 text-light px-4 py-2 ml-2 new_theme_btn"
                    >
                      <AiOutlineMail className="mr-2"></AiOutlineMail>
                      support@invozio.com
                    </Button>
                  </div>
                </div>
              </div>
              <div className="col-md-5"></div>
            </div>
          </div>
        </div>
      </section>

      <ContactUsForm
        t={t}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        register={register}
        language={language}
        errors={errors}
      />
      <Footer dashboardFooter={dashboardFooter} />
    </>
  );
};

export default ContactUs;
